/**
 * HighlightMarker
 * 
 * @Author: Focci
 * @Date: 2024-09-14 14:10:42
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-14 14:10:42
 */

// import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import { Marker } from 'react-map-gl'

export default function HighlightMarker({ data, ...props }) {
  const tf = useTranslations('profile')

  const { name } = data?.properties?.[0] || {}
  const lng = data?.center?.[0]
  const lat = data?.center?.[1]
  
  return lng && lat && (
    <Marker
      latitude={lat}
      longitude={lng}
      style={{ zIndex: 6 }}
      {...props}
    >
      <div
        style={{ textStroke: '4px #fff' }}
        className="
          p-2 text-f.9 font-bold text absolute left-1/2 -translate-x-1/2 
          bottom-full pointer-events-none whitespace-nowrap"
      >
        {name}
      </div>
      <div className="px-2 py-1 rounded-sm text-white bg-primary cursor-pointer">
        {tf('searchProperty')}
      </div>
    </Marker>
  )
}

// HighlightMarker.propTypes = {
//   className: PropTypes.string,
// }
